





import { Vue, Component } from 'vue-property-decorator';
import ErrorsService from '.';

@Component
export default class ErrorBoundary extends Vue {
  get error(): boolean {
    return this.service.error;
  }
  get errorMessage(): string {
    return this.service.errorMessage;
  }

  private service: ErrorsService = ErrorsService.instance;
}
